import { Step } from './CreatePartnerOrganization.enum';

export const titles = {
    [Step.ONBOARDING]: 'Welcome to Newo, Partner!',
    [Step.CREATE_ORGANIZATION]: 'Create your free partner account',
    [Step.AGENT_SETUP]:
        'Talk to the AI Supervisor Adrian to finish setting up your partner account.'
};

export const subtitles = {
    [Step.ONBOARDING]: 'Watch this short introduction video:',
    [Step.CREATE_ORGANIZATION]:
        'We’d love to know more about you to personalize your onboarding experience.',
    [Step.AGENT_SETUP]: ''
};
